export default __webpack_public_path__ + "static/media/airplane.2abf8ccd.png";